<div class="main">

  <div class="header d-flex flex-dir-col gap-8">
    <div class="d-flex just-space">
      <span class="h5-b">Device Health</span>
      <button class="transparent-button pointer-cursor" (click)=" closeModal()"><img src="{{imgSrc}}assets/icons/cross-icon.svg" /></button>
    </div>
    <div class="d-flex gap-8">
      <span class="h7 grey">Device ID:</span>
      <span class="h7 grey"> {{deviceId}}</span>
      <span *ngIf="deviceVersion" class="d-flex gap-4 align-center">
        <span class="h7 grey">Device Version:</span>
        <span class="h7 grey d-flex gap-4 align-center" [ngClass]="{
          'link' : isReleaseNotesPresent
        }" (click)="openReleaseNotes()"> 
        {{ deviceVersion }} 
        <svg
        *ngIf="isReleaseNotesPresent"
         width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" 
        [matTooltip]="'Click to view the Release Notes for this Version'"
        >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99967 13.6663C11.1293 13.6663 13.6663 11.1293 13.6663 7.99967C13.6663 4.87006 11.1293 2.33301 7.99967 2.33301C4.87006 2.33301 2.33301 4.87006 2.33301 7.99967C2.33301 11.1293 4.87006 13.6663 7.99967 13.6663ZM7.99967 14.6663C11.6816 14.6663 14.6663 11.6816 14.6663 7.99967C14.6663 4.31778 11.6816 1.33301 7.99967 1.33301C4.31778 1.33301 1.33301 4.31778 1.33301 7.99967C1.33301 11.6816 4.31778 14.6663 7.99967 14.6663Z" fill="#0937B2"/>
          <rect x="7.33301" y="7.33301" width="1.33333" height="4" rx="0.666667" fill="#0937B2"/>
          <ellipse cx="7.99967" cy="5.99967" rx="0.666667" ry="0.666667" fill="#0937B2"/>
        </svg>
          
        </span>
      </span>
    </div>
  </div>
  <div *ngIf="loader" class="spinner-wrapper">
    <mis-loader [mobileView]="false"></mis-loader>
  </div>
  <div class="child-2 d-flex align-center gap-24">
    <div class="date-picker">
      <div class="form-field block d-flex">
        <div class="date-select space-flex d-flex">
          <input misTzDp class="h6" type="text" readonly [dpConfig]="startDatepickerConfig"
            class="form-field-input-text" placeholder="{{ 'Select' }}" positionX="start" [(ngModel)]="selectedDate"
            (ngModelChange)="changeFormat1($event)" />
          <img src="{{imgSrc}}assets/icons/date-picker.svg" alt="" class="date-icon data-picker-icon" />
        </div>
      </div>
    </div>

    <div class="dropdown">
      <mis-dropdown [data]="logTypeDropdown" [searchEnabled]="false" width="218px" (onChange)="selectDutyType($event)"
        [selectedItem]="selectedLogType"></mis-dropdown>
    </div>
  </div>

  <div class="table-container-view">






    <table mat-table [dataSource]="filterResponse" multiTemplateDataRows class="mat-elevation-z8" class="table-container">
      <!-- <ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">
                <th mat-header-cell  *matHeaderCellDef></th>
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <th mat-header-cell *matHeaderCellDef> {{column}} </th>
                <td mat-cell *matCellDef="let element"> {{element[column]}} </td>
              </ng-container> -->

      <ng-container matColumnDef="Expand">
        <th mat-header-cell *matHeaderCellDef aria-label="row actions">Expand</th>
        <td mat-cell *matCellDef="let element" style="cursor:pointer ;" class="b-right p-l-8" (click)="toggleRow(element)">
          <!-- <button mat-icon-button aria-label="expand row"> -->
            <img *ngIf="!element.expanded"  src="{{imgSrc}}assets/icons/line-down-arrow.svg" />
            <img *ngIf="element.expanded"   src="{{imgSrc}}assets/icons/up-arrow.svg" />
          <!-- </button> -->
        </td>
      </ng-container>

      <ng-container matColumnDef="Time">
        <th mat-header-cell class="p-l-8 w-150 h7-b" *matHeaderCellDef> Time </th>
        <td mat-cell class="b-right p-l-8 h7" *matCellDef="let element">{{changeDateFormat(element.recordedTime)}} </td>
      </ng-container>
      <ng-container matColumnDef="App">
        <th mat-header-cell class="p-l-8" *matHeaderCellDef> App </th>
        <td mat-cell  class="b-right p-l-8 h7" *matCellDef="let element"> {{element.appType == "1" ? "Platform" : "Business"}} </td>
      </ng-container>
      <ng-container matColumnDef="Log Type">
        <th mat-header-cell class="p-l-8" *matHeaderCellDef> Log Type </th>
        <td mat-cell  class="b-right p-l-8 h7" *matCellDef="let element"> {{getLogTypeText(element.logType)}} </td>
      </ng-container>
      <ng-container  matColumnDef="Details">
        <th mat-header-cell class="p-l-8" *matHeaderCellDef> Details </th>
        <td  [ngClass]="{'event-f-text':element.expanded}"
        class="p-l-8 event-text h7" mat-cell *matCellDef="let element"> {{element.event}} </td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <!-- <ng-container *ngIf="element.expanded" matColumnDef="Details">
        <th mat-header-cell *matHeaderCellDef> Details </th>
        <td mat-cell *matCellDef="let element"> {{element.event.splice}} </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <!-- <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row"
        [class.example-expanded-row]="element.expanded" (click)="toggleRow(element)">
      </tr> -->
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay" class="example-detail-row"></tr>
    </table>


  </div>
  <!-- <div class="get-more d-flex just-center">
    <button class="transparent-button pointer-cursor" (click)="loadMore()"><span class="h7-b">Get more</span></button>
  </div> -->

</div>



<!-- <div class="wrapper">



  <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">
   

    <ng-container matColumnDef="Expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button aria-label="expand row">
          <img src="assets/icons/male.svg" />
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="Time">
      <th mat-header-cell *matHeaderCellDef> Time </th>
      <td mat-cell *matCellDef="let element">{{element.recordedTime | date:'yyyy-MM-dd HH:mm:ss'}} </td>
    </ng-container>
    <ng-container matColumnDef="App">
      <th mat-header-cell *matHeaderCellDef> App </th>
      <td mat-cell *matCellDef="let element"> {{element.appType == "1" ? "Platform" : "Business"}} </td>
    </ng-container>
    <ng-container matColumnDef="Log Type">
      <th mat-header-cell *matHeaderCellDef> Log Type </th>
      <td mat-cell *matCellDef="let element"> {{getLogTypeText(element.logType)}} </td>
    </ng-container>
    <ng-container matColumnDef="Details">
      <th mat-header-cell *matHeaderCellDef> Details </th>
      <td mat-cell *matCellDef="let element"> {{element.event}} </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail" *ngIf="false">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length">
        <div class="example-element-detail" [@detailExpand]="element.expanded ? 'expanded' : 'collapsed'">
          <table class="detail-table">
            <tr>
              <th>Avatar</th>
              <th>Phone</th>
              <th>Website</th>
              <th>Company</th>
            </tr>
            <tr>
              <td><img src="https://picsum.photos/id/{{element.id}}/150/100" alt="thumbnail"></td>
              <td>{{element.phone}}</td>
              <td>{{element.website}}</td>
              <td>{{element.company}}</td>
            </tr>
          </table>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row"
      [class.example-expanded-row]="element.expanded" (click)="toggleRow(element)">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>

</div> -->





 <!-- <table class="table-container InPremise-table">
            <div class="table-scroll">
              <thead>
                <tr>
                  <th *ngFor="let col of device_health_column">{{ col }}</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of  filterResponse">
                <td><img src="assets/icons/line-down-arrow.svg" alt=""></td>
                  <td >{{item.recordedTime | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                  <td>{{item.appType == "1" ? "Platform" : "Business"}}</td>
                  <td >{{getLogTypeText(item.logType)}}</td>
                  <td >{{item.event}}</td>
                </tr>
              </tbody>
            </div>
          </table> -->